/*
  Inaya Pharmacy: display-only currency converter (replaces the Beast and 7cloud currency apps).
  Markup, currency list and texts are in snippets/inaya-currency.liquid.
  Prices are stored and charged in the store currency. This script rewrites the text of every
  <span class="money"> using Shopify's public rates (/services/javascripts/currencies.js).
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-inaya-currency]');
  if (!root) { return; }

  // The Beast currency app is still switched on for this theme: leave the prices to it.
  if (window.DoublyGlobal) { return; }

  var BASE = root.getAttribute('data-base');
  var CHOICE_KEY = 'inaya_currency';
  var RATES_KEY = 'inaya_currency_rates';
  var RATES_MAX_AGE = 6 * 60 * 60 * 1000;

  var button = root.querySelector('.InayaCur__Button');
  var panel = root.querySelector('.InayaCur__Panel');
  var codeLabel = root.querySelector('[data-inaya-currency-code]');
  var options = Array.prototype.slice.call(root.querySelectorAll('[data-currency]'));
  var decimals = {};
  options.forEach(function (option) {
    decimals[option.getAttribute('data-currency')] = parseInt(option.getAttribute('data-decimals'), 10);
  });

  var current = BASE;
  var rates = null;
  var touched = false;
  var scheduled = false;

  function read(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function write(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function cachedRates() {
    try {
      var saved = JSON.parse(read(RATES_KEY));
      if (saved && saved.r && saved.r[BASE] && Date.now() - saved.t < RATES_MAX_AGE) { return saved.r; }
    } catch (e) {}
    return null;
  }

  function loadRates(done) {
    var script = document.createElement('script');
    script.src = '/services/javascripts/currencies.js';
    script.onload = function () {
      var all = window.Currency && window.Currency.rates;
      if (!all || !all[BASE]) { done(null); return; }
      var kept = {};
      Object.keys(decimals).forEach(function (code) {
        if (all[code]) { kept[code] = all[code]; }
      });
      write(RATES_KEY, JSON.stringify({ t: Date.now(), r: kept }));
      done(kept);
    };
    script.onerror = function () { done(null); };
    document.head.appendChild(script);
  }

  function parseAmount(text) {
    var clean = text
      .replace(/[٠-٩]/g, function (digit) { return digit.charCodeAt(0) - 0x0660; })
      .replace(/,/g, '');
    var match = clean.match(/-?\d+(?:\.\d+)?/);
    return match ? parseFloat(match[0]) : NaN;
  }

  function format(amount, code) {
    var parts = amount.toFixed(decimals[code]).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.') + ' ' + code;
  }

  function update(span) {
    var text = span.textContent;
    if (span.getAttribute('data-inaya-shown') !== text) {
      // A new price, or the theme rewrote this one: the text is the store-currency price
      span.setAttribute('data-inaya-original', text);
    }
    var original = span.getAttribute('data-inaya-original');
    var out = original;
    if (current !== BASE && rates && rates[current]) {
      var amount = parseAmount(original);
      if (!isNaN(amount)) { out = format(amount * rates[BASE] / rates[current], current); }
    }
    if (out !== text) { span.textContent = out; }
    span.setAttribute('data-inaya-shown', out);
    if (out !== original) {
      span.setAttribute('title', original.replace(/\s+/g, ' ').trim());
    } else if (span.hasAttribute('title')) {
      span.removeAttribute('title');
    }
  }

  function cartNotes() {
    var converted = current !== BASE && !!rates;
    var buttons = document.querySelectorAll('.Cart__Checkout');
    for (var i = 0; i < buttons.length; i++) {
      var previous = buttons[i].previousElementSibling;
      var hasNote = !!previous && previous.classList.contains('InayaCur__CartNote');
      if (converted && !hasNote) {
        var note = document.createElement('p');
        note.className = 'InayaCur__CartNote';
        note.textContent = root.getAttribute('data-cart-note');
        buttons[i].parentNode.insertBefore(note, buttons[i]);
      } else if (!converted && hasNote) {
        previous.parentNode.removeChild(previous);
      }
    }
  }

  function apply() {
    scheduled = false;
    if (current === BASE && !touched) { return; }
    touched = true;
    var spans = document.querySelectorAll('span.money');
    for (var i = 0; i < spans.length; i++) { update(spans[i]); }
    cartNotes();
  }

  function schedule() {
    if (scheduled) { return; }
    scheduled = true;
    window.requestAnimationFrame(apply);
  }

  function show(code) {
    current = code;
    codeLabel.textContent = code;
    options.forEach(function (option) {
      if (option.getAttribute('data-currency') === code) {
        option.setAttribute('aria-current', 'true');
      } else {
        option.removeAttribute('aria-current');
      }
    });
    schedule();
  }

  function choose(code, remember) {
    if (!(code in decimals)) { code = BASE; }
    if (remember) { write(CHOICE_KEY, code); }
    if (code === BASE || (rates && rates[code])) { show(code); return; }
    loadRates(function (loaded) {
      if (loaded && loaded[code]) { rates = loaded; show(code); } else { show(BASE); }
    });
  }

  function open(state) {
    panel.hidden = !state;
    button.setAttribute('aria-expanded', state ? 'true' : 'false');
  }

  button.addEventListener('click', function (event) {
    event.stopPropagation();
    open(panel.hidden);
  });

  panel.addEventListener('click', function (event) {
    event.stopPropagation();
    var option = event.target.closest('[data-currency]');
    if (!option) { return; }
    choose(option.getAttribute('data-currency'), true);
    open(false);
    button.focus();
  });

  document.addEventListener('click', function () { open(false); });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !panel.hidden) { open(false); button.focus(); }
  });

  // Prices added or rewritten later (cart drawer, filters, variant change) are converted too
  new MutationObserver(function () {
    if (current === BASE && !touched) { return; }
    schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  root.hidden = false;
  rates = cachedRates();

  var saved = read(CHOICE_KEY);
  if (saved) {
    choose(saved, false);
  } else if (window.fetch) {
    // First visit: start in the currency of the visitor's country, as the old app did
    var byCountry = {};
    try { byCountry = JSON.parse(root.getAttribute('data-countries')) || {}; } catch (e) {}
    window.fetch('/browsing_context_suggestions.json?country[enabled]=true')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (read(CHOICE_KEY)) { return; }
        var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        var code = (country && byCountry[country]) || BASE;
        write(CHOICE_KEY, code);
        if (code !== BASE) { choose(code, false); }
      })
      .catch(function () {});
  }
})();
